/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock, RankMock, RecordMock, StageMock} from './mock'

export const getHomepage = createAsyncThunk(
  'CricketWarsV2/getHomepage',
  async (_, store: any) => {
    // todo mock
    // return {data: HomepageMock}
    const resp = await http.post(
      '/live/activity/cricket_2026_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getRank = createAsyncThunk(
  'CricketWarsV2/getRank',
  async (p: any, store: any) => {
    // todo mock
    // return {data: RankMock}
    const resp = await http.post(
      '/live/activity/cricket_2026_rank_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getRuleInfo = createAsyncThunk(
  'CricketWarsV2/getRuleInfo',
  async (_, store: any) => {
    const resp = await http.post(
      '/live/activity/cricket_2026_stage_rule_info',
      {},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getStageTaskInfo = createAsyncThunk(
  'CricketWarsV2/getStageTaskInfo',
  async (p: any, store: any) => {
    // todo mock
    // return {data: StageMock}
    const resp = await http.post(
      '/live/commonactivity/get_stage_task_info',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getStageDoneReward = createAsyncThunk(
  'CricketWarsV2/getStageDoneReward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_stage_done_reward',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data
  }
)

export const getRewardByTag = createAsyncThunk(
  'CricketWarsV2/getRewardByTag',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_reward_by_tag',
      {...p},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState = {
  homepage: null,
  rank: null,
  rule: null,
  stageTask: {
    rewardList: [],
    stages: [],
    stage_score: 0,
  },
}

export const CricketWarsV2Slice = createSlice({
  name: 'CricketWarsV2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const {data} = action.payload
      state.homepage = data
    })
    builder.addCase(getRuleInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      state.rule = data
    })
    builder.addCase(getRank.fulfilled, (state, action) => {
      const {data} = action.payload
      state.rank = data
    })
    builder.addCase(getStageTaskInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      const rewardList = []
      data?.stages?.forEach((item) => {
        rewardList.push(...item?.reward_infos)
      })
      state.stageTask = {
        ...data,
        rewardList,
      }
    })
  },
})

export default CricketWarsV2Slice.reducer
